module.exports = __webpack_public_path__ + "img/matthew winston sr, 1959.1a2826cf.jpg";